const therapistSteps = [
  {
    step: '01',
    title: 'Profil Oluştur',
    desc: 'Ücretsiz kayıt olun, telefon doğrulaması yapın ve admin onayından geçin.',
    icon: 'ri-user-add-line',
  },
  {
    step: '02',
    title: 'Görünürlük Modu Seç',
    desc: 'Standart veya Sessiz Kariyer modunu seçin. Profiliniz kontrollü şekilde gösterilir.',
    icon: 'ri-eye-off-line',
  },
  {
    step: '03',
    title: 'Uyumlu Talepleri Gör',
    desc: 'Şehir ve uzmanlığınıza göre yüksek uyumlu spa işletme taleplerini inceleyin.',
    icon: 'ri-magic-line',
  },
  {
    step: '04',
    title: 'Güvenli Chat',
    desc: 'Kabul ederseniz platform içinde güvenli yazılı chat açılır.',
    icon: 'ri-message-3-line',
  },
  {
    step: '05',
    title: 'Çift Taraflı Onay',
    desc: 'Telefon ve diğer bilgiler sadece çift taraflı onayla paylaşılır.',
    icon: 'ri-shield-check-line',
  },
];

const spaSteps = [
  {
    step: '01',
    title: 'Kayıt ve Onay',
    desc: 'Spa işletmenizi kaydedin, admin onayından geçin ve güvenli kullanıcı havuzuna katılın.',
    icon: 'ri-building-line',
  },
  {
    step: '02',
    title: 'Personel İhtiyacı',
    desc: 'Şube, uzmanlık ve diğer kriterlere göre personel ihtiyacı talebi oluşturun.',
    icon: 'ri-file-list-2-line',
  },
  {
    step: '03',
    title: 'Uyumlu Terapistler',
    desc: 'Algoritma en uyumlu terapistleri önerir. Favoriler, filtreler ve CRM ile yönetin.',
    icon: 'ri-search-line',
  },
  {
    step: '04',
    title: 'İletişim Talebi',
    desc: 'İstediğiniz terapiste iletişim talebi gönderin. Kredi düşmez.',
    icon: 'ri-send-plane-line',
  },
  {
    step: '05',
    title: 'Terapist Kabul Ederse',
    desc: 'Terapist kabul ederse chat açılır ve kredi kullanılır. Sadece gerçek bağlantıda ödeme.',
    icon: 'ri-chat-check-line',
  },
];

export default function HowItWorksSection() {
  return (
    <section id="nasil-calisir" className="w-full bg-off-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-soft-gold-100 text-soft-gold-700 text-xs font-semibold rounded-full mb-4">
            Süreç
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
            Nasıl Çalışır
          </h2>
          <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto">
            Terapist ve spa işletmesi için iki ayrı, şeffaf ve kontrollü akış. Kullanıcı deneyimi odaklı süreç.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {/* Therapist Flow */}
          <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100 shadow-soft">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-dark-teal-50 flex items-center justify-center">
                <i className="ri-user-smile-line text-dark-teal-500 text-lg" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-deep-navy-500">Terapist Akışı</h3>
                <p className="text-xs text-gray-400">Profesyoneller için</p>
              </div>
            </div>
            <div className="space-y-4">
              {therapistSteps.map((s, i) => (
                <div key={s.step} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-8 h-8 rounded-full bg-dark-teal-500 flex items-center justify-center text-white text-xs font-bold shrink-0">
                      {s.step}
                    </div>
                    {i < therapistSteps.length - 1 && (
                      <div className="w-px flex-1 bg-dark-teal-200 my-1 min-h-[24px]" />
                    )}
                  </div>
                  <div className="pb-4">
                    <h4 className="text-sm font-semibold text-deep-navy-500 mb-1">{s.title}</h4>
                    <p className="text-xs text-gray-500 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Spa Flow */}
          <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100 shadow-soft">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-soft-gold-100 flex items-center justify-center">
                <i className="ri-store-2-line text-soft-gold-700 text-lg" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-deep-navy-500">Spa İşletmesi Akışı</h3>
                <p className="text-xs text-gray-400">İşletmeler için</p>
              </div>
            </div>
            <div className="space-y-4">
              {spaSteps.map((s, i) => (
                <div key={s.step} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-8 h-8 rounded-full bg-soft-gold-500 flex items-center justify-center text-white text-xs font-bold shrink-0">
                      {s.step}
                    </div>
                    {i < spaSteps.length - 1 && (
                      <div className="w-px flex-1 bg-soft-gold-300 my-1 min-h-[24px]" />
                    )}
                  </div>
                  <div className="pb-4">
                    <h4 className="text-sm font-semibold text-deep-navy-500 mb-1">{s.title}</h4>
                    <p className="text-xs text-gray-500 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Credit Note */}
        <div className="max-w-3xl mx-auto mt-10 md:mt-12">
          <div className="flex items-start gap-3 bg-soft-gold-50 rounded-xl p-4 md:p-5 border border-soft-gold-200">
            <i className="ri-information-line text-soft-gold-600 text-xl shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-semibold text-soft-gold-800 mb-1">Kredi Notu</h4>
              <p className="text-xs md:text-sm text-soft-gold-700 leading-relaxed">
                Talep gönderirken kredi düşmez. Terapist kabul ederse kredi kullanılır ve güvenli chat açılır. Sadece gerçek bağlantı oluştuğunda ödeme yapılır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}